export default __webpack_public_path__ + "static/BannerJsonImageAndText-6f14d190a9233a7af3c1f31d5d59729f.jpg";